import React from "react";
import PeopleComponent from "@iventis/people-app/src/people";
import PageWithAppBar from "./page-with-appbar";

export default () => (
    <PageWithAppBar>
        <PeopleComponent />
    </PageWithAppBar>
);
